import { useEffect, useState } from "react";

import TenantCommunityInboxApi, { IPost } from "../../api/tenantCommunityInboxPost";
import useCallApi from "../../hooks/useCallApi";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import {Routes} from "../../routes/Routes";
import {useNavigate} from "react-router-dom";

const useTenantCommunityInboxContainer = () => {
  const { callApi, loading } = useCallApi();
  const { isRTL } = useRTL();
  const navigate = useNavigate();

  const [pageLoading, setPageLoading] = useState(true);

  const [allPosts, setAllPosts] = useState<
  IPost[]
  >([]);

  const [page, setPage] = useState(1);

  const handleChangePage = (
    tenantCommunityInboxPost: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleCreate = () => {
    navigate(Routes.addTenantCommunityInboxPost);
  }

  useEffect(() => {
    setPageLoading(true);
    callApi(TenantCommunityInboxApi.getAll(), (posts: IPost[]) => {
      setAllPosts(posts);
      setPageLoading(false);
    });
  }, [isRTL]);

  return {
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage: 6,
    loading,
    rows: allPosts,
    handleCreate
  };
};

export default useTenantCommunityInboxContainer;
